import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => {
  return {
    bigXBox: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: theme.spacing(2),
    },
    wrapper: {
      justifyContent: "center",
      display: "flex",
      alignItems: "center",
      paddingTop: "24px",
      paddingBottom: "24px",
    },
    secondaryText: {
      color: "var(--text-secondary, rgba(0, 0, 0, 0.60))",
      textAlign: "center",
      fontWeight: 500,
      fontSize: "14px !important",
      lineHeight: "143%",
    },
    noDataText: {
      color: "var(--text-secondary, rgba(0, 0, 0, 0.60))",
      textAlign: "center",
      fontFeatureSettings: "'clig' off, 'liga' off",
      fontSize: "16px !important",
      fontWeight: 500,
      lineHeight: "150%",
    },
  };
});
